export const USER_ID_KEY: string = 'user:id';
export const ACCESS_TOKEN_KEY: string = 'tokens:access';
export const REFRESH_TOKEN_KEY: string = 'tokens:refresh';
export const NEXT_URL: string = 'url:next';
